import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";

export const initialBraintreeReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const braintreeSlice = createSlice({
    name: "Braintree",
    initialState: { ...initialBraintreeReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default braintreeSlice;
